import { m as motion } from 'framer-motion';
import { fadeVariants } from '../hooks/useTravelerButton';
import { jsx as _jsx } from "react/jsx-runtime";
const FadeMotion = _ref => {
  let {
    children,
    motionKey
  } = _ref;
  return /*#__PURE__*/_jsx(motion.span, {
    animate: "visible",
    initial: "hidden",
    variants: fadeVariants,
    children: children
  }, motionKey);
};
export default FadeMotion;
//# sourceMappingURL=FadeMotion.js.map